// extracted by mini-css-extract-plugin
module.exports = {"button":"load-more-m__button__1VjlF","default":"load-more-m__default__19Swl","dark":"load-more-m__dark__3yY4_","light":"load-more-m__light__2RtNB"};